import VmpDocUne from './src/main';

/* istanbul ignore next */
VmpDocUne.install = function (Vue) {
  Vue.component(VmpDocUne.name, VmpDocUne);
};

export default VmpDocUne;
